"use client";
import {
  useSeparator
} from "./IX2MD5WD.js";
import {
  useCompositeContext
} from "./53KINMNA.js";
import {
  createElement,
  createHook,
  forwardRef
} from "./YIF72NQG.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./4R3V3JGP.js";

// src/composite/composite-separator.tsx
import { invariant } from "@ariakit/core/utils/misc";
var TagName = "hr";
var useCompositeSeparator = createHook(function useCompositeSeparator2(_a) {
  var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
  const context = useCompositeContext();
  store = store || context;
  invariant(
    store,
    process.env.NODE_ENV !== "production" && "CompositeSeparator must be wrapped in a Composite component."
  );
  const orientation = store.useState(
    (state) => state.orientation === "horizontal" ? "vertical" : "horizontal"
  );
  props = useSeparator(__spreadProps(__spreadValues({}, props), { orientation }));
  return props;
});
var CompositeSeparator = forwardRef(function CompositeSeparator2(props) {
  const htmlProps = useCompositeSeparator(props);
  return createElement(TagName, htmlProps);
});

export {
  useCompositeSeparator,
  CompositeSeparator
};
